import {store} from '@/store';
import {AUTH_GET_TOKEN, AUTH_GET_USERNAME, AUTH_LOGOUT} from '@/store/modules/authentication/types';
import {DISABLE_LOADING, ENABLE_LOADING} from '@/store/types';
import axios, {AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';
import {CONFIG} from '@/config';
import AuthService from '@/services/auth.service';

const auth = new AuthService();

export interface IHttpService {
  http: AxiosInstance;
  httpBlob: AxiosInstance;
}

export class HttpService implements IHttpService {
  get http(): AxiosInstance {
    const instance = axios.create({
      headers: this.getHeaders()
    });

    instance.interceptors.request.use(this._requestSuccess, this._requestError);
    instance.interceptors.response.use(this._responseSuccess, this._responseError);

    return instance;
  }

  get httpBlob(): AxiosInstance {
    const instance = axios.create({
      responseType: 'arraybuffer',
      headers: this.getHeaders()
    });

    instance.interceptors.request.use(this._requestSuccess, this._requestError);
    instance.interceptors.response.use(this._responseSuccess, this._responseError);

    return instance;
  }

  get json(): AxiosInstance {
    const instance = axios.create();
    return instance;
  }

  public getHeaders(username: string | null = null, token: string | null = null) {
       return { Authorization: `Bearer ${token || sessionStorage.getItem('token')}`,
    }
  }

  private _requestSuccess(req: AxiosRequestConfig) {
    if (req.url !== `${CONFIG.URL.NEODASH_API}/api/notification`)
      store.dispatch(ENABLE_LOADING);
    return req;
  }

  private _requestError(err: AxiosError) {
    store.dispatch(DISABLE_LOADING);
    return Promise.reject(err);
  }

  private _responseSuccess(res: AxiosResponse) {
    store.dispatch(DISABLE_LOADING);
    return Promise.resolve(res);
  }

  private _responseError(err: AxiosError) {
    if (err.request.status === 401) {
        auth.login();
    }

    store.dispatch(DISABLE_LOADING);
    return Promise.reject(err);
  }
}

export const httpService = new HttpService();

export const http = httpService.http;
